import React from "react";
import { TextButton, useIcon } from "@SeemplicityDev/shared";
import PageActions from "../Components/PageActions";

// S3 arn: (dev) arn:aws:s3:::seem-eoy-2024/background.mp4
const BackgroundVideo =
  "https://seem-eoy-2024.s3.eu-central-1.amazonaws.com/background.mp4";

interface IntroPageProps {
  getNextPage: () => void;
  onExit: () => void;
  onMute: () => void;
  isMuted: boolean;
  onDownload: () => void;
}

const IntroPage: React.FC<IntroPageProps> = ({
  getNextPage,
  onExit,
  onMute,
  isMuted,
  onDownload,
}) => {
  const { getSvg } = useIcon("LIGHT");
  return (
    <div className="eoy-page intro-page">
      <video autoPlay muted loop playsInline className="bg-video">
        <source src={BackgroundVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div className="page-actions-container">
        <PageActions
          onMute={onMute}
          onDownload={onDownload}
          onExit={onExit}
          isMuted={isMuted}
        />
      </div>
      <img src={getSvg("logo")} alt="Seemplicity" className="seem-logo" />

      <h1>
        Looking Back — <span>2025</span> Was Incredible!
      </h1>
      <div className="subtitle">
        {`We collected highlights on your\n accomplishments this year with Seemplicity`}
      </div>
      <TextButton
        label={"Let's Go!"}
        onClick={getNextPage}
        className="eoy-action-button-inverted"
      />
    </div>
  );
};

export default IntroPage;
